module.exports = __webpack_public_path__ + "img/VIDYA-W.6472c249.png";